import { render, staticRenderFns } from "./failedCard.vue?vue&type=template&id=5faa262e&scoped=true"
import script from "./failedCard.vue?vue&type=script&lang=js"
export * from "./failedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa262e",
  null
  
)

export default component.exports